import { useTranslation } from 'react-i18next'

export function SkipLink() {
  const { t } = useTranslation('common')

  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[1000] focus:px-4 focus:py-2 focus:bg-gray-900 focus:text-white focus:rounded-md focus:outline-none focus:ring-2 focus:ring-white"
    >
      {t('aria.skipToContent')}
    </a>
  )
}
